// extracted by mini-css-extract-plugin
export default {"peopleNameCell":"people_peopleNameCell__r0McM","peopleActions":"people_peopleActions__LrOou"};